<template>
  <div class="page-content-wrapper user-list-page"  v-check-permission="'list-payments'">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card m-b-20">
            <div class="card-block">

              <h4 class="mt-0 header-title">Pagos</h4>
              <p class="text-muted m-b-30 font-14">Desde aquí podras administrar los pagos.</p>

              <div class="table-rep-plugin">
                <div>

                  <div class="row">
                    <div class="col-md-4 mb-3">
                      <input type="number" @keyup.enter="search()" class="form-control" v-model="params.dni" placeholder="DNI" aria-controls="datatable">
                    </div>

                    <div class="col-md-8 mb-3">
                      <button class="btn btn-primary bootstrap-touchspin-up" @click="search()" type="button"><i class="fa fa-search"></i></button>
                      <button class="btn btn-primary" @click="clearFilters()">Limpiar</button>
                      <button class="btn btn-primary" @click="getAll()"><i class="fa fa-refresh" aria-hidden="true"></i> Mostrar todos / Actualizar listado</button>
                      <router-link :to="{ name: 'add-payment' }" v-check-permission="'edit-payments'" class="btn btn-info"><i class="fa fa-plus-circle"></i> Nuevo</router-link>
                    </div>
                  </div>

                  <div class="filters-content">
                    <div class="filters">
                      <div class="row">
                        <div class="col-md-4 mb-3" v-if="currentUser.admin">
                          <input type="email" @keyup.enter="search()" class="form-control" v-model="params.email" placeholder="Email" aria-controls="datatable">
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4 mb-3">
                          <select id="career" class="custom-select form-control" v-model="params.career">
                            <option :value="null">Carrera</option>
                            <option v-for="career in careers" v-bind:value="career._id">
                              {{ career.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4 mb-3">
                          <select class="custom-select form-control d-block" v-model="params.paymentStatus">
                            <option :value="null">Estado</option>
                            <option v-for="state in paymentStatus" :value="state.value">
                              {{ state.text }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-2 mb-3">
                          <select class="custom-select form-control" v-model="params.month">
                            <option :value="null">Mes</option>
                            <option v-for="m in months" v-bind:value="m.value">
                              {{ m.value }} ({{ m.text }})
                            </option>
                          </select>
                        </div>
                        <div class="col-md-2 mb-3">
                          <select class="custom-select form-control" v-model="params.year">
                            <option :value="null">Año</option>
                            <option v-for="i in years" v-bind:value="i">
                              {{ i }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <button class="btn btn-outline-info btn-circle open-filters" @click="toggleFilters()"><i class="fa fa-angle-down"></i></button> &nbsp; <small>Desplegar más filtros</small>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <div class="table-rep-plugin">

                <div class="row pull-right mb-2">
                  <div class="col-md-12">
                    <small><b>({{ payments.total }} registros)</b></small>
                  </div>
                </div>

                <div class="table-responsive b-0" data-pattern="priority-columns">

                  <table class="table table-striped">
                    <thead>
                    <tr>
                      <th>DNI</th>
                      <th>Apellido y Nombre</th>
                      <th>Carrera</th>
                      <th>Descripción</th>
                      <th>Tipo</th>
                      <th>Monto</th>
                      <th>Monto Pagado</th>
                      <th>Estado</th>
                      <th>Nº de Recibo</th>
                      <th>Creado el</th>
                      <th>Vencimiento</th>
                      <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="payment in payments.docs" :key="payment._id">
                      <td><b>{{ payment.file.personalData.dni }}</b></td>
                      <td><b>{{ payment.file.personalData.lastName + ' ' + payment.file.personalData.firstName }}</b></td>
                      <td>{{ payment.career.name }}</td>
                      <td><b>{{ payment.title }}</b> <small v-if="payment.description"><br>({{ payment.description }})</small></td>
                      <td>
                        <span class="badge badge-warning" v-if="payment.paymentType == 'fee'">Cuota</span>
                        <span class="badge badge-info" v-if="payment.paymentType == 'enrollment'">Matrícula</span>
                        <span class="badge badge-dark" v-if="payment.paymentType == 'custom'">Personalizado</span>
                      </td>
                      <td>${{ payment.amount }}</td>
                      <td>${{ payment.amountPaid }}</td>
                      <td>
                        <span class="badge badge-primary" v-if="payment.paymentStatus == 'pending'">Pendiente</span>
                        <span class="badge badge-success" v-if="payment.paymentStatus == 'approved'">Pagado</span>
                      </td>
                      <td v-if="payment.receiptNumber">{{ payment.receiptNumber }}</td><td v-else>--</td>
                      <td>{{ payment.createdAt | moment("DD/MM/YYYY") }}</td>
                      <td>{{ payment.dueDate | moment("DD/MM/YYYY") }}</td>
                      <td class="pull-right">
                        <router-link :to="{ name: 'edit-payment', params: { id: payment._id }}" v-check-permission="'edit-payments'" class="text-info mr-3"><i class="fa fa-pencil"></i></router-link>
                        <a href="javascript:void(0);" v-check-permission="'edit-payments'" class="text-primary"  @click="deletePayment(payment._id)"><i class="fa fa-minus-circle"></i></a>
                      </td>
                    </tr>
                    <tr v-if="payments.docs && payments.docs.length === 0">
                      <td colspan="12">Para ver los pagos utilice los filtros y seleccione buscar...</td>
                    </tr>
                    </tbody>
                  </table>

                  <pagination v-bind:current-page="params.page" v-bind:total-pages="payments.pages">
                  </pagination>
                </div>
              </div>
            </div>
          </div>
        </div> <!-- end col -->
      </div> <!-- end row -->

    </div><!-- container -->

  </div>
</template>


<script>
  import config from '../data/config'
  import paymentStatus from '../data/paymentStatus'
  import months from '../data/months'
  import pagination from '../components/Pagination.vue'

  export default {
    name: 'list-payments',

    components: {
      pagination
    },

    created () {
      this.getAllCareers();
      //this.getAll();
      this.cleanPayments();

      this.$on('pageChanged:pagination', val => {
        this.params.page = val;
        this.getAllPayments();
      })
    },

    data () {
      return {
        params: {
          limit: config.pagination.limit,
          page: 1,
          dni: null,
          email: null,
          career: null,
          paymentStatus: null,
          month: null,
          year: null
        },
        paymentStatus: paymentStatus,
        currentUser: this.$store.state.auth.user,
        months: months
      }
    },

    computed: {
      payments: function () {
        return this.$store.getters.getAllPayments
      },

      careers: function () {
        return this.$store.getters.getAllCareers
      },

      years: function () {
        var minYear = 2018;
        var currentYear = (new Date()).getFullYear();
        var years = [];
        var i;

        for (i = minYear; i <= (currentYear + 1); i++) {
          years.push(i);
        }

        return years;
      }
    },

    methods: {

      getAllPayments () {
        this.$loader.loading();
        this.$store.dispatch('getAllPayments', { params : this.params })
          .then((response) => {
            this.$loader.close();
          })
          .catch((response) => {
            this.$loader.close();
            this.$message.error({text: response.message});
          })
      },

      setPayment (payment) {
        this.$store.dispatch('setPayment', { payment : payment })
      },

      getAll: function () {
        this.clearFilters();
        this.getAllPayments();
      },

      search: function () {
        if(this.params.dni || this.params.email || this.params.career || this.params.paymentStatus || this.params.month || this.params.year) {
          this.params.page = 1;
          this.getAllPayments();
        }
      },

      clearFilters() {
        this.params.dni = null;
        this.params.email = null;
        this.params.career = null;
        this.params.paymentStatus = null;
        this.params.month = null;
        this.params.year = null;
        this.params.page = 1;
      },

      cleanPayments() {
        this.$store.dispatch('cleanPayments');
      },

      getAllCareers () {
        this.$loader.loading();
        this.$store.dispatch('getAllCareers')
          .then((response) => {
            this.$loader.close();
          })
          .catch((response) => {
            this.$loader.close();
          })
      },

      toggleFilters() {
        window.toggleFilters('.open-filters');
      },


      deletePayment (id) {
        var self = this;

        this.$message.delete().then(function (result) {

          if(result.value) {
            self.$store.dispatch('deletePayment', { id : id })
              .then((response) => {
                if(response.success) {
                  self.$message.success();
                } else {
                  self.$message.error({text: response.message});
                }
              })
              .catch((response) => {
                self.$message.error({text: response.message});
              })
          }

        })

      },

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/screens/PaymentListScreen.vue